import { HttpClient } from '@angular/common/http';
import {Component, OnDestroy, OnInit, Inject, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';

import {RoleService} from '../../services/role.service';
import {Observable, Subject, map, of, startWith, throwError} from 'rxjs';
import { Role } from '../../models/role';
import { AlertDialog, AlertDialogConfig } from '../alert/dialog';
import { PermissionService } from '../../services/permission.service';
import { Permission } from '../../models/permission';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocomplete } from '@angular/material/autocomplete';
@Component({
  standalone: false,
  selector: 'app-add-role',
  templateUrl: './add-role-template.html',
  styleUrls: ['./add-role-style.scss'],
})
export class AddRoleComponent implements OnInit, OnDestroy {
  showMoreOptions_ = false;

  isExternal = false;
  readonly nameMaxLength = 24;
  private created_ = false;
  private unsubscribe_ = new Subject<void>();
  permissionsListDictionary : Array<any> = [];
  filteredPermissionsByName!: Observable<any[]> | undefined ;
  selectedOptions: Permission[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('autoP', {static: false}) matAutocomplete!: MatAutocomplete ;
  roleForm: FormGroup = this.fb_.group({
    name: [this.data?.name, [Validators.required, ]],
    permissions: [this.data.permissions && Array.isArray(this.data.permissions) ? this.data.permissions : [], [Validators.required]],
  });
  constructor(
    public dialogRef: MatDialogRef<AddRoleComponent>,
    private roleService: RoleService,
    private permissionsService: PermissionService,
    private readonly route_: ActivatedRoute,
    private readonly fb_: FormBuilder,
    private readonly dialog_: MatDialog,
    private readonly router_: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  get name(): AbstractControl | null {
    return this.roleForm.get('name');
  }

  get permissions() : FormGroup {
    return this.roleForm.get("permissions") as FormGroup
  }

  dump(o:any){
    console.log(' ==> o = ', o)
  }

  ngOnInit(): void {
    this.permissionsService.get()
          .subscribe(result => {
            this.permissionsListDictionary = result;
          }
          );
  }

  ngOnDestroy(): void {
    this.unsubscribe_.next();
    this.unsubscribe_.complete();
  }


  hasUnsavedChanges(): boolean {
    return this.roleForm.dirty;
  }

  isCreateDisabled(): boolean {
    return !this.roleForm.valid;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  add(): void {
    const role =  {
      id: this.data.id,
      name: (this.name)? this.name.value : null,
      permissions: this.permissions ? this.permissions.value : null,
    }

    this.roleService.addRole(role)
    .subscribe( _ => {
      if(!_.status){
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de l\'ajout de ce rôle : ' + _.message,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
      }else{
        this.dialogRef.close();
      }
    },
    error => {
      const config = {
        title: 'Erreur',
        message: 'Une erreur est survenue lors de l\'ajout de cet utilisateur : ' + error,
        confirmLabel: 'OK'
      } as AlertDialogConfig;
      this.dialog_.open(AlertDialog, {data: config});
      return throwError(error);
    }
    );
  }


  canDeactivate(): boolean {
    return this.roleForm.pristine || this.created_;
  }

  selectedOption(value: any){
    this.selectedOptions.push(value);
  }

  removeOption(option: Permission) {
    const index = this.selectedOptions.indexOf(option);
    if (index >= 0) {
      this.selectedOptions.splice(index, 1);
    }
  }
}
